export default __webpack_public_path__ + "static/Logo-min-7a3db431e0b1b07eae01fa38261d903c.png";